import { useCallback } from 'react';
import { useStandaloneUsageTracker } from '../context/UsageTrackerContext';
import { useMergeTrackEventProps } from './useMergeTrackEventProps';
export function useTrackStandaloneEvent(beacon = false) {
  const standaloneTracker = useStandaloneUsageTracker(beacon);
  const mergeEventProps = useMergeTrackEventProps();
  const trackStandaloneEvent = useCallback((eventName, eventProps) => {
    standaloneTracker.track('Marketplace', eventName, mergeEventProps(eventProps));
  }, [mergeEventProps, standaloneTracker]);
  return trackStandaloneEvent;
}
export function createTrackStandaloneEventHook(eventName) {
  return function useTrackStandaloneEventHook(beacon = false) {
    const trackStandaloneEvent = useTrackStandaloneEvent(beacon);
    const trackEvent = useCallback(eventProps => {
      trackStandaloneEvent(eventName, eventProps);
    }, [trackStandaloneEvent]);
    return trackEvent;
  };
}